import { jsx as t, jsxs as v, Fragment as j } from "react/jsx-runtime";
import { AlertGroup as dn, Alert as un, AlertVariant as Le, AlertActionCloseButton as hn, Page as pn, Modal as Tt, ModalVariant as mn, TextContent as fn, Text as Be, Button as $, Spinner as kt, FormHelperText as je, HelperText as ze, HelperTextItem as Je, Popover as gn, Icon as Ve, FormGroup as xt, NumberInput as yn, ValidatedOptions as Y, InputGroup as ke, InputGroupItem as _e, TextInput as xe, Select as Se, SelectList as Ee, SelectOption as Ye, MenuToggle as Ae, MenuToggleStatus as Ze, TextInputGroup as St, TextInputGroupMain as Et, ChipGroup as Qe, Chip as Xe, TextInputGroupUtilities as At, Switch as bn, TextArea as Rt, Title as vn, Card as Cn, CardHeader as wn, CardTitle as In, CardBody as Tn, Grid as kn, GridItem as dt, PageSection as xn, JumpLinks as Sn, JumpLinksItem as En, ButtonVariant as Ie, Checkbox as An, Radio as Rn, MenuFooter as Nn, getDefaultOUIAId as On, getOUIAProps as Dn, Dropdown as Pn, DropdownList as Mn, DropdownItem as ut, Masthead as Fn, MastheadToggle as Ln, PageToggleButton as Bn, MastheadBrand as Vn, MastheadContent as _n, Toolbar as we, ToolbarContent as Ue, ToolbarItem as W, Avatar as Un, Bullseye as $n, EmptyState as qn, EmptyStateIcon as ht, EmptyStateHeader as Kn, EmptyStateBody as Hn, EmptyStateFooter as Gn, EmptyStateActions as Wn, SearchInput as jn, Divider as zn, Pagination as Jn, Badge as Yn } from "@patternfly/react-core";
import { createContext as Nt, useContext as Ot, useRef as Z, useEffect as re, useCallback as he, useState as A, useMemo as q, forwardRef as Dt, useId as Pt, Fragment as Mt, Children as Ft, Component as Lt, isValidElement as Bt } from "react";
import { useTranslation as K } from "react-i18next";
import { NetworkError as Vt } from "@keycloak/keycloak-admin-client";
import Zn from "keycloak-js";
import { ExclamationCircleIcon as Qn, HelpIcon as pt, EyeIcon as Xn, EyeSlashIcon as er, TimesIcon as _t, CubeIcon as tr, PaypalIcon as nr, InstagramIcon as rr, BitbucketIcon as ar, MicrosoftIcon as ir, TwitterIcon as lr, StackOverflowIcon as sr, OpenshiftIcon as or, LinkedinIcon as cr, GoogleIcon as dr, GitlabIcon as ur, FacebookSquareIcon as hr, GithubIcon as pr, MinusCircleIcon as mr, PlusCircleIcon as Ut, EllipsisVIcon as fr, BarsIcon as gr, SearchIcon as yr, SyncAltIcon as br } from "@patternfly/react-icons";
import { useFormContext as Re, Controller as se, useController as et, FormProvider as vr, useWatch as Cr } from "react-hook-form";
import { get as U, cloneDeep as wr, intersectionBy as Ir } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as V } from "@patternfly/react-styles";
import P from "@patternfly/react-styles/css/components/MenuToggle/menu-toggle";
import Tr from "@patternfly/react-icons/dist/esm/icons/caret-down-icon";
import kr from "@patternfly/react-icons/dist/esm/icons/check-circle-icon";
import xr from "@patternfly/react-icons/dist/esm/icons/exclamation-circle-icon";
import Sr from "@patternfly/react-icons/dist/esm/icons/exclamation-triangle-icon";
import { Table as Er, TableVariant as Ar, Thead as Rr, Tr as ve, Th as Me, Tbody as mt, Td as ie, ExpandableRowContent as Nr, ActionsColumn as Or, TableText as Dr } from "@patternfly/react-table";
import './main.css';function tt(e, n) {
  const r = Nt(n);
  return r.displayName = e, r;
}
const Pr = ["error", "errorMessage"], Fe = "error_description";
function Mr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Vt)
    return Lr(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Fr(e) {
  if (!(e instanceof Vt))
    return;
  const n = e.responseData;
  return $t(n);
}
function $t(e) {
  if (typeof e == "object" && e !== null && Fe in e && typeof e[Fe] == "string")
    return e[Fe];
}
function Lr(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of Pr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Br = () => Math.floor(Math.random() * 1e3);
function Vr(e) {
  return e != null;
}
function nt(e) {
  const n = Ot(e);
  if (Vr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function _r() {
  const e = Z(!1), n = Z(/* @__PURE__ */ new Set());
  re(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, i) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const l = Number(setTimeout(s, i));
    n.current.add(l);
    function s() {
      n.current.delete(l), a();
    }
    return function() {
      clearTimeout(l), n.current.delete(l);
    };
  }, []);
}
function Ur({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    dn,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: i, description: l }, s) => /* @__PURE__ */ t(
        un,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Le[a],
          component: "p",
          variantLabel: "",
          title: i,
          actionClose: /* @__PURE__ */ t(
            hn,
            {
              title: i,
              onClose: () => n(r)
            }
          ),
          children: l && /* @__PURE__ */ t("p", { children: l })
        },
        r
      ))
    }
  );
}
const $r = 8e3, qt = tt(
  "AlertContext",
  void 0
), ri = () => nt(qt), qr = ({ children: e }) => {
  const { t: n } = K(), r = _r(), [a, i] = A([]), l = (c) => i((h) => h.filter((d) => d.id !== c)), s = he(
    (c, h = Le.success, d) => {
      const y = {
        id: Br(),
        message: c,
        variant: h,
        description: d
      };
      i((b) => [y, ...b]), r(() => l(y.id), $r);
    },
    [r]
  ), o = he(
    (c, h) => {
      const d = n(c, { error: Mr(h) }), y = Fr(h);
      s(d, Le.danger, y);
    },
    [s, n]
  ), u = q(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ v(qt.Provider, { value: u, children: [
    /* @__PURE__ */ t(Ur, { alerts: a, onCloseAlert: l }),
    e
  ] });
}, Kr = (e) => {
  const { t: n } = K(), r = e.error, a = Hr(r) || $t(r)?.replace(/\+/g, " ");
  console.error(r);
  function i() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(pn, { children: /* @__PURE__ */ t(
    Tt,
    {
      variant: mn.small,
      title: a ? "" : n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t($, { variant: "primary", onClick: i, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(fn, { children: a ? /* @__PURE__ */ t(Be, { children: n(a) }) : /* @__PURE__ */ t(Be, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Hr(e) {
  return typeof e == "string" ? e : e instanceof Error ? e.message : null;
}
function Gr(e, n, r) {
  const [a, i] = A(
    () => e.getItem(n) ?? r
  ), l = he((s) => {
    i(s), e.setItem(n, s);
  }, []);
  return re(() => {
    i(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && i(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, l];
}
function Kt(e, n, r) {
  const a = q(
    () => JSON.stringify(r),
    [r]
  ), [i, l] = Gr(
    e,
    n,
    a
  ), s = q(() => JSON.parse(i), [i]), o = he(
    (u) => l(JSON.stringify(u)),
    []
  );
  return [s, o];
}
const Ht = tt(
  "HelpContext",
  void 0
), Wr = () => nt(Ht), jr = ({ children: e }) => {
  const [n, r] = Kt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Ht.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, zr = () => Nt(void 0);
let $e;
const ai = () => {
  const e = Ot($e);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, ii = ({
  environment: e,
  children: n
}) => {
  $e = zr();
  const r = Z(!1), [a, i] = A(!1), [l, s] = A(), o = q(() => {
    const c = new Zn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [e]);
  re(() => {
    if (r.current)
      return;
    o.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => i(!0)).catch((h) => s(h)), r.current = !0;
  }, [o]);
  const u = new URLSearchParams(window.location.search);
  return l || u.get("error_description") ? /* @__PURE__ */ t(
    Kr,
    {
      error: l || u.get("error_description")
    }
  ) : a ? /* @__PURE__ */ t($e.Provider, { value: { environment: e, keycloak: o }, children: /* @__PURE__ */ t(qr, { children: /* @__PURE__ */ t(jr, { children: n }) }) }) : /* @__PURE__ */ t(kt, {});
};
function li() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const si = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: i,
  buttonVariant: l,
  buttonTestRole: s,
  onContinue: o,
  component: u = $,
  children: c,
  ...h
}) => {
  const [d, y] = A(!1);
  return /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(
      u,
      {
        variant: l,
        onClick: () => y(!0),
        isDisabled: i,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      Tt,
      {
        variant: "small",
        ...h,
        title: e,
        isOpen: d,
        onClose: () => y(!1),
        actions: [
          /* @__PURE__ */ t(
            $,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                y(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            $,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => y(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, Gt = ({ message: e, ...n }) => /* @__PURE__ */ t(je, { ...n, children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { icon: /* @__PURE__ */ t(Qn, {}), variant: "error", children: e }) }) }), Wt = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1
}) => {
  const { enabled: i } = Wr();
  return i ? /* @__PURE__ */ t(gn, { bodyContent: e, children: /* @__PURE__ */ v(j, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (l) => l.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(Ve, { isInline: r, children: /* @__PURE__ */ t(pt, {}) })
      }
    ),
    a && /* @__PURE__ */ t(Ve, { isInline: r, children: /* @__PURE__ */ t(pt, {}) })
  ] }) }) : null;
};
function pe(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const ae = ({
  name: e,
  label: n,
  labelIcon: r,
  error: a,
  children: i,
  ...l
}) => /* @__PURE__ */ v(
  xt,
  {
    label: n || e,
    fieldId: e,
    labelIcon: r ? /* @__PURE__ */ t(Wt, { helpText: r, fieldLabelId: e }) : void 0,
    ...l,
    children: [
      i,
      a && /* @__PURE__ */ t(Gt, { "data-testid": `${e}-helper`, message: a.message })
    ]
  }
), oi = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...i
}) => {
  const {
    control: l,
    formState: { errors: s }
  } = Re();
  return /* @__PURE__ */ t(
    ae,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        se,
        {
          ...r,
          name: e,
          control: l,
          render: ({ field: o }) => {
            const u = !!r.rules?.required, c = pe(r.rules?.min), h = o.value ?? r.defaultValue, d = (y) => o.onChange(
              c !== void 0 ? Math.max(y, Number(c)) : y
            );
            return /* @__PURE__ */ t(
              yn,
              {
                ...i,
                id: e,
                value: h,
                validated: s[e] ? Y.error : Y.default,
                required: u,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => d(h + 1),
                onMinus: () => d(h - 1),
                onChange: (y) => {
                  const b = Number(y.currentTarget.value);
                  d(isNaN(b) ? r.defaultValue : b);
                }
              }
            );
          }
        }
      )
    }
  );
}, Jr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = K(), [i, l] = A(!0);
  return /* @__PURE__ */ v(ke, { children: [
    /* @__PURE__ */ t(_e, { isFill: !0, children: /* @__PURE__ */ t(
      xe,
      {
        ...r,
        type: i ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      $,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => l(!i),
        children: i ? /* @__PURE__ */ t(Xn, {}) : /* @__PURE__ */ t(er, {})
      }
    )
  ] });
}, jt = Dt(
  (e, n) => /* @__PURE__ */ t(Jr, { ...e, innerRef: n })
);
jt.displayName = "PasswordInput";
const ci = (e) => {
  const { labelIcon: n, ...r } = e, a = !!pe(e.rules?.required), i = e.defaultValue ?? "", { field: l, fieldState: s } = et({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ v(
    ae,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          jt,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? Y.error : Y.default,
            isDisabled: e.isDisabled,
            ...r,
            ...l
          }
        ),
        e.helperText && /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: e.helperText }) }) })
      ]
    }
  );
}, Yr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  controller: i,
  labelIcon: l,
  isDisabled: s,
  onSelect: o,
  ...u
}) => {
  const {
    control: c,
    formState: { errors: h }
  } = Re(), [d, y] = A(!1), b = pe(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    ae,
    {
      name: n,
      label: r,
      isRequired: b,
      error: U(h, n),
      labelIcon: l,
      children: /* @__PURE__ */ t(
        se,
        {
          ...i,
          name: n,
          control: c,
          render: ({ field: { onChange: C, value: x } }) => /* @__PURE__ */ t(
            Se,
            {
              ...u,
              variant: "default",
              onClick: () => y(!d),
              onOpenChange: () => y(!1),
              selected: te(a) ? a.filter(
                (p) => Array.isArray(x) ? x.includes(p.key) : x === p.key
              ).map((p) => p.value) : x,
              toggle: (p) => /* @__PURE__ */ t(
                Ae,
                {
                  id: e || n.slice(n.lastIndexOf(".") + 1),
                  ref: p,
                  onClick: () => y(!d),
                  isExpanded: d,
                  isFullWidth: !0,
                  status: U(h, n) ? Ze.danger : void 0,
                  "aria-label": r,
                  isDisabled: s,
                  children: te(a) ? a.find(
                    (m) => m.key === (Array.isArray(x) ? x[0] : x)
                  )?.value : x
                }
              ),
              onSelect: (p, m) => {
                const S = m?.toString(), T = Array.isArray(x) ? [S] : S;
                o ? o(T, C) : C(T), y(!1);
              },
              isOpen: d,
              children: /* @__PURE__ */ t(Ee, { "data-testid": `select-${n}`, children: a.map((p) => /* @__PURE__ */ t(Ye, { value: le(p), children: rt(p) ? p : p.value }, le(p))) })
            }
          )
        }
      )
    }
  );
}, Ce = (e) => rt(e) ? e : e.value, Zr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: i = [],
  controller: l,
  labelIcon: s,
  placeholderText: o,
  onFilter: u,
  variant: c,
  ...h
}) => {
  const {
    control: d,
    formState: { errors: y }
  } = Re(), [b, C] = A(!1), [x, p] = A(""), [m, S] = A(0), [T, w] = A([]), f = Z(), I = pe(l.rules?.required) === !0, N = c === ue.typeaheadMulti, R = a.filter(
    (g) => Ce(g).toLowerCase().startsWith(x.toLowerCase())
  ), B = q(
    () => R.map((g, E) => /* @__PURE__ */ t(
      Ye,
      {
        value: le(g),
        isFocused: m === E,
        children: Ce(g)
      },
      le(g)
    )),
    [m, R]
  ), _ = (g, E) => {
    E.value.includes(g) ? (E.onChange(E.value.filter((O) => O !== g)), te(a) && w(
      T.filter((O) => O.key !== g)
    )) : (E.onChange([...E.value, g]), te(a) && w([
      ...T,
      a.find((O) => O.key === g)
    ]));
  }, M = (g, E) => {
    const O = R[m];
    switch (C(!0), g.key) {
      case "Enter": {
        g.preventDefault(), p(N ? "" : Ce(O)), _(le(O), E), C(!1), S(0);
        break;
      }
      case "Tab":
      case "Escape": {
        C(!1), E.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === ue.typeahead && E.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        g.preventDefault();
        let D = 0;
        g.key === "ArrowUp" && (m === 0 ? D = a.length - 1 : D = m - 1), g.key === "ArrowDown" && (m === a.length - 1 ? D = 0 : D = m + 1), S(D);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    ae,
    {
      name: n,
      label: r,
      isRequired: I,
      error: U(y, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        se,
        {
          ...l,
          name: n,
          control: d,
          render: ({ field: g }) => /* @__PURE__ */ t(
            Se,
            {
              ...h,
              onOpenChange: () => C(!1),
              selected: te(a) ? a.filter(
                (E) => Array.isArray(g.value) ? g.value.includes(E.key) : g.value === E.key
              ).map((E) => E.value) : g.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (E) => /* @__PURE__ */ t(
                Ae,
                {
                  ref: E,
                  id: e || n.slice(n.lastIndexOf(".") + 1),
                  variant: "typeahead",
                  onClick: () => {
                    C(!b), f.current?.focus();
                  },
                  isExpanded: b,
                  isFullWidth: !0,
                  status: U(y, n) ? Ze.danger : void 0,
                  children: /* @__PURE__ */ v(St, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      Et,
                      {
                        placeholder: o,
                        value: c === ue.typeahead && g.value ? te(a) ? a.find(
                          (O) => O.key === (Array.isArray(g.value) ? g.value[0] : g.value)
                        )?.value : g.value : x,
                        onClick: () => C(!b),
                        onChange: (O, D) => {
                          p(D), u?.(D);
                        },
                        onKeyDown: (O) => M(O, g),
                        autoComplete: "off",
                        innerRef: f,
                        role: "combobox",
                        isExpanded: b,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === ue.typeaheadMulti && Array.isArray(g.value) && /* @__PURE__ */ t(Qe, { "aria-label": "Current selections", children: g.value.map(
                          (O, D) => /* @__PURE__ */ t(
                            Xe,
                            {
                              onClick: (oe) => {
                                oe.stopPropagation(), g.onChange(
                                  g.value.filter(
                                    (H) => H !== le(O)
                                  )
                                );
                              },
                              children: te(a) ? [
                                ...a,
                                ...T,
                                ...i
                              ].find((oe) => O === oe.key)?.value : Ce(O)
                            },
                            D
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(At, { children: (!!x || g.value) && /* @__PURE__ */ t(
                      $,
                      {
                        variant: "plain",
                        onClick: () => {
                          p(""), g.onChange(N ? [] : ""), f?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(_t, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (E, O) => {
                E?.stopPropagation();
                const D = O?.toString();
                N && Array.isArray(g.value) ? (p(""), _(D || "", g)) : (g.onChange(Array.isArray(g.value) ? [D] : D), C(!1));
              },
              isOpen: b,
              children: /* @__PURE__ */ t(Ee, { children: B })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const te = (e) => typeof e[0] != "string", rt = (e) => typeof e == "string", le = (e) => rt(e) ? e : e.key, Qr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(Yr, { ...n }) : /* @__PURE__ */ t(Zr, { ...n, variant: e }), qe = (e) => e?.includes("${"), Ke = (e) => e.substring(2, e.length - 1), ne = (e, n, r, a) => {
  const i = n || r, l = qe(i) ? Ke(i) : i, s = a ? `${a}.${l}` : l;
  return e(s || "");
}, He = (e, n) => ne(e, n.displayName, n.name), Xr = ["username", "firstName", "lastName", "email"], zt = (e) => e && Xr.includes(e), Q = (e) => `${zt(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, di = (e) => e.replaceAll(".", "🍺"), ea = (e) => e.replaceAll("🍺", ".");
function ui(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const i = Object.assign(
      {},
      a.params?.map((l) => qe(l?.toString()) ? r(Ke(l)) : l)
    );
    n(Q(a.field), {
      message: r(
        qe(a.errorMessage) ? Ke(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...i,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Ne({
  required: e
}) {
  return e;
}
function hi(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ft(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ft);
}
function ft(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const pi = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...i
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Re();
  return /* @__PURE__ */ t(
    ae,
    {
      hasNoPaddingTop: !0,
      name: i.name,
      isRequired: i.rules?.required === !0,
      label: i.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        se,
        {
          control: o,
          name: i.name,
          defaultValue: s,
          render: ({ field: { onChange: u, value: c } }) => /* @__PURE__ */ t(
            bn,
            {
              ...i,
              id: i.name,
              "data-testid": ea(i.name),
              label: e,
              isChecked: n ? c === "true" : c,
              onChange: (h, d) => {
                const y = n ? d.toString() : d;
                i.onChange?.(h, d), u(y);
              }
            }
          )
        }
      )
    }
  );
}, mi = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: i } = et({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    ae,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: i.error,
      children: /* @__PURE__ */ t(
        Rt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: i.error ? Y.error : Y.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, fi = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, i = !!pe(e.rules?.required), l = e.defaultValue ?? "", { field: s, fieldState: o } = et({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ v(
    ae,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: i,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          xe,
          {
            isRequired: i,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? Y.error : Y.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: r }) }) })
      ]
    }
  );
}, ta = Rt, gi = ({ icon: e }) => {
  const n = na(e);
  return /* @__PURE__ */ t(Ve, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function na(e) {
  switch (e) {
    case "github":
      return pr;
    case "facebook":
      return hr;
    case "gitlab":
      return ur;
    case "google":
      return dr;
    case "linkedin":
    case "linkedin-openid-connect":
      return cr;
    case "openshift-v4":
      return or;
    case "stackoverflow":
      return sr;
    case "twitter":
      return lr;
    case "microsoft":
      return ir;
    case "bitbucket":
      return ar;
    case "instagram":
      return rr;
    case "paypal":
      return nr;
    default:
      return tr;
  }
}
const ra = "_title_180i0_2", aa = {
  title: ra
}, Jt = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...i
}) => /* @__PURE__ */ t(
  vn,
  {
    headingLevel: r,
    size: a,
    className: aa.title,
    id: e,
    tabIndex: 0,
    ...i,
    children: n
  }
), ia = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const i = Pt();
  return /* @__PURE__ */ v(Cn, { id: i, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(wn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(In, { tabIndex: 0, children: /* @__PURE__ */ t(Jt, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(Tn, { className: "kc-form-panel__body", children: n })
  ] });
}, la = (e) => {
  const { title: n, children: r, scrollId: a, ...i } = e;
  return /* @__PURE__ */ t("section", { ...i, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(Jt, { id: a, title: n }),
    r
  ] }) });
}, sa = "_panel_1cdve_1", oa = "_sticky_1cdve_5", gt = {
  panel: sa,
  sticky: oa
}, ca = "kc-main-content-page-container", yt = (e) => e.replace(/\s+/g, "-"), da = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const i = q(
    () => n.filter(({ isHidden: l }) => !l),
    [n]
  );
  return /* @__PURE__ */ v(kn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(dt, { md: 8, sm: 12, children: i.map(({ title: l, panel: s }) => {
      const o = yt(l.toLowerCase());
      return /* @__PURE__ */ t(Mt, { children: r ? /* @__PURE__ */ t(
        ia,
        {
          scrollId: o,
          title: l,
          className: gt.panel,
          children: s
        }
      ) : /* @__PURE__ */ t(la, { scrollId: o, title: l, children: s }) }, l);
    }) }),
    /* @__PURE__ */ t(dt, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(xn, { className: gt.sticky, children: /* @__PURE__ */ t(
      Sn,
      {
        isVertical: !0,
        scrollableSelector: `#${ca}`,
        label: e,
        offset: 100,
        children: i.map(({ title: l }) => {
          const s = yt(l.toLowerCase());
          return (
            // note that JumpLinks currently does not work with spaces in the href
            /* @__PURE__ */ t(
              En,
              {
                href: `#${s}`,
                "data-testid": `jump-link-${s}`,
                children: l
              },
              l
            )
          );
        })
      }
    ) }) })
  ] });
}, ua = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, yi = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: i,
  ...l
}) => /* @__PURE__ */ t(
  $,
  {
    variant: "primary",
    isDisabled: e && !ua(e, a, r) || n,
    ...l,
    type: "submit",
    children: i
  }
), ha = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, pa = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const i = q(
    () => r.map((l) => ({
      key: l,
      value: e(`locale_${l}`, ha(l) ?? l)
    })).sort((l, s) => l.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return i.length ? /* @__PURE__ */ t(vr, { ...n, children: /* @__PURE__ */ t(
    Qr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...i],
      variant: i.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, me = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: i
}) => {
  const l = ne(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), u = U(s, Q(r.name));
  return /* @__PURE__ */ v(
    xt,
    {
      label: He(e, r) || "",
      fieldId: r.name,
      isRequired: Ne(r),
      labelIcon: l ? /* @__PURE__ */ t(Wt, { helpText: l, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ v(ke, { children: [
          i,
          o
        ] }) : i,
        u && /* @__PURE__ */ t(
          Gt,
          {
            "data-testid": `${r.name}-helper`,
            message: u.message
          }
        )
      ]
    },
    r.name
  );
}, ma = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...i
}) => /* @__PURE__ */ t(me, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  fa,
  {
    t: e,
    form: n,
    "aria-label": He(e, r),
    name: Q(r.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: He(e, r)
    }),
    ...i
  }
) }), fa = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: i,
  isDisabled: l = !1,
  defaultValue: s,
  id: o,
  ...u
}) => {
  const { register: c, setValue: h, control: d } = a, y = Cr({
    name: n,
    control: d,
    defaultValue: s || ""
  }), b = q(() => Array.isArray(y) && y.length !== 0 ? y : s || [""], [y]), C = (T) => {
    m([...b.slice(0, T), ...b.slice(T + 1)]);
  }, x = () => {
    m([...b, ""]);
  }, p = (T, w) => {
    m([...b.slice(0, T), w, ...b.slice(T + 1)]);
  }, m = (T) => {
    const w = T.flatMap((f) => f);
    h(n, w, {
      shouldDirty: !0
    });
  }, S = r.startsWith("html") ? r.substring(6) : "text";
  return re(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: o, children: b.map((T, w) => /* @__PURE__ */ v(Mt, { children: [
    /* @__PURE__ */ v(ke, { children: [
      /* @__PURE__ */ t(_e, { isFill: !0, children: /* @__PURE__ */ t(
        xe,
        {
          "data-testid": n + w,
          onChange: (f, I) => p(w, I),
          name: `${n}.${w}.value`,
          value: T,
          isDisabled: l,
          type: S,
          ...u
        }
      ) }),
      /* @__PURE__ */ t(_e, { children: /* @__PURE__ */ t(
        $,
        {
          "data-testid": "remove" + w,
          variant: Ie.link,
          onClick: () => C(w),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: b.length === 1 || l,
          children: /* @__PURE__ */ t(mr, {})
        }
      ) })
    ] }),
    w === b.length - 1 && /* @__PURE__ */ v(
      $,
      {
        variant: Ie.link,
        onClick: x,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !T || l,
        children: [
          /* @__PURE__ */ t(Ut, {}),
          " ",
          e(i || "add")
        ]
      }
    )
  ] }, w)) });
}, bt = (e) => {
  const { form: n, inputType: r, attribute: a } = e, i = Ne(a), l = r.startsWith("multiselect"), s = l ? An : Rn, o = a.validators?.options?.options || [], u = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    se,
    {
      name: Q(a.name),
      control: n.control,
      defaultValue: "",
      render: ({ field: h }) => /* @__PURE__ */ t(j, { children: o.map((d) => /* @__PURE__ */ t(
        s,
        {
          id: d,
          "data-testid": d,
          label: ne(e.t, u[d], d, c),
          value: d,
          isChecked: h.value.includes(d),
          onChange: () => {
            l ? h.value.includes(d) ? h.onChange(
              h.value.filter((y) => y !== d)
            ) : h.onChange([...h.value, d]) : h.onChange([d]);
          },
          readOnly: a.readOnly,
          isRequired: i
        },
        d
      )) })
    }
  ) });
}, ga = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: i,
  menuAppendTo: l,
  direction: s,
  width: o,
  maxHeight: u,
  toggleIcon: c,
  className: h,
  isDisabled: d,
  children: y,
  ...b
}) => {
  const [C, x] = A(!1), p = Z(), m = () => {
    x(!C), n(!C);
  }, S = () => l === "parent" && p.current?.parentElement || "inline", T = Ft.toArray(
    y
  );
  return /* @__PURE__ */ t(
    Se,
    {
      ref: p,
      maxMenuHeight: Te(u),
      isScrollable: !0,
      popperProps: {
        appendTo: S(),
        direction: s,
        width: Te(o)
      },
      ...b,
      onClick: m,
      onOpenChange: (w) => {
        w !== C && m();
      },
      selected: a,
      onSelect: (w, f) => {
        r?.(f || ""), m();
      },
      toggle: (w) => /* @__PURE__ */ t(
        Ae,
        {
          id: e,
          ref: w,
          className: h,
          onClick: m,
          isExpanded: i,
          "aria-label": b["aria-label"],
          icon: c,
          isDisabled: d,
          isFullWidth: !0,
          children: T.find((f) => f.props.value === a)?.props.children || a || b["aria-label"]
        }
      ),
      isOpen: i,
      children: /* @__PURE__ */ t(Ee, { children: y })
    }
  );
}, ya = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: i,
  validated: l,
  placeholderText: s,
  maxHeight: o,
  width: u,
  toggleIcon: c,
  direction: h,
  selections: d,
  typeAheadAriaLabel: y,
  chipGroupComponent: b,
  chipGroupProps: C,
  footer: x,
  isDisabled: p,
  children: m,
  ...S
}) => {
  const [T, w] = A(""), [f, I] = A(0), N = Z(), R = Ft.toArray(
    m
  ), B = () => {
    r?.(!S.isOpen);
  }, _ = (M) => {
    const g = R[f];
    switch (r?.(!0), M.key) {
      case "Enter": {
        M.preventDefault(), i !== J.typeaheadMulti ? w(g.props.value) : w(""), n?.(g.props.value), r?.(!1), I(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        i === J.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        M.preventDefault();
        let E = 0;
        M.key === "ArrowUp" && (f === 0 ? E = R.length - 1 : E = f - 1), M.key === "ArrowDown" && (f === R.length - 1 ? E = 0 : E = f + 1), I(E);
        break;
      }
    }
  };
  return /* @__PURE__ */ v(
    Se,
    {
      ...S,
      onClick: B,
      onOpenChange: (M) => r?.(M),
      onSelect: (M, g) => {
        n?.(g || ""), a?.(""), w("");
      },
      maxMenuHeight: Te(o),
      popperProps: { direction: h, width: Te(u) },
      toggle: (M) => /* @__PURE__ */ t(
        Ae,
        {
          ref: M,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: c,
          isDisabled: p,
          isExpanded: S.isOpen,
          isFullWidth: !0,
          status: l === "error" ? Ze.danger : void 0,
          children: /* @__PURE__ */ v(St, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              Et,
              {
                placeholder: s,
                value: i === J.typeahead && d ? d : T,
                onClick: B,
                onChange: (g, E) => {
                  w(E), a?.(E);
                },
                onKeyDown: (g) => _(g),
                autoComplete: "off",
                innerRef: N,
                role: "combobox",
                isExpanded: S.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": y,
                children: i === J.typeaheadMulti && Array.isArray(d) && (b || /* @__PURE__ */ t(Qe, { ...C, children: d.map((g, E) => /* @__PURE__ */ t(
                  Xe,
                  {
                    onClick: (O) => {
                      O.stopPropagation(), n?.(g);
                    },
                    children: g
                  },
                  E
                )) }))
              }
            ),
            /* @__PURE__ */ t(At, { children: !!T && /* @__PURE__ */ t(
              $,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), w(""), a?.(""), N?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(_t, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ee, { children: m }),
        x && /* @__PURE__ */ t(Nn, { children: x })
      ]
    }
  );
};
var J = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(J || {});
const Te = (e) => typeof e == "number" ? e + "px" : e, ba = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(ga, { ...n }) : /* @__PURE__ */ t(ya, { ...n, variant: e }), vt = (e) => {
  const { t: n, form: r, inputType: a, attribute: i } = e, [l, s] = A(!1), [o, u] = A(""), c = a === "multiselect", h = (p, m) => {
    c ? m.value.includes(p) ? m.onChange(m.value.filter((S) => S !== p)) : Array.isArray(m.value) ? m.onChange([...m.value, p]) : m.onChange([p]) : m.onChange(p === m.value ? "" : p);
  }, d = i.validators?.options?.options || [], y = i.annotations?.inputOptionLabels || {}, b = i.annotations?.inputOptionLabelsI18nPrefix, C = (p) => ne(e.t, y[p], p, b), x = (p) => d.filter(
    (m) => C(m).toLowerCase().includes(o.toLowerCase())
  ).map((m) => /* @__PURE__ */ t(
    Ye,
    {
      selected: p === m,
      value: m,
      children: C(m)
    },
    m
  ));
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    se,
    {
      name: Q(i.name),
      defaultValue: "",
      control: r.control,
      render: ({ field: p }) => /* @__PURE__ */ t(
        ba,
        {
          toggleId: i.name,
          onToggle: (m) => s(m),
          onClear: () => h("", p),
          onSelect: (m) => {
            const S = m.toString();
            h(S, p), Array.isArray(p.value) || s(!1);
          },
          selections: c && Array.isArray(p.value) ? p.value.map((m) => C(m)) : C(p.value),
          variant: c ? J.typeaheadMulti : d.length >= 10 ? J.typeahead : J.single,
          "aria-label": n("selectOne"),
          isOpen: l,
          isDisabled: i.readOnly,
          onFilter: (m) => (u(m), x(p.value)),
          children: x(p.value)
        }
      )
    }
  ) });
}, va = (e) => {
  const { form: n, attribute: r } = e, a = Ne(r);
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    ta,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Q(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a
    }
  ) });
}, G = (e) => {
  const { form: n, inputType: r, attribute: a } = e, i = Ne(a), l = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    xe,
    {
      id: a.name,
      "data-testid": a.name,
      type: l,
      placeholder: a.readOnly ? "" : ne(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: i,
      ...n.register(Q(a.name))
    }
  ) });
}, Ge = {
  text: G,
  textarea: va,
  select: vt,
  "select-radiobuttons": bt,
  multiselect: vt,
  "multiselect-checkboxes": bt,
  "html5-email": G,
  "html5-tel": G,
  "html5-url": G,
  "html5-number": G,
  "html5-range": G,
  "html5-datetime-local": G,
  "html5-date": G,
  "html5-month": G,
  "html5-time": G,
  "multi-input": ma
}, bi = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: i,
  hideReadOnly: l = !1,
  renderer: s
}) => {
  const o = q(() => {
    if (!r.attributes)
      return [];
    const u = l ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: u.filter(
        (h) => h.group === c.name
      )
    }));
  }, [
    l,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    da,
    {
      label: e("jumpToSection"),
      sections: o.filter((u) => u.attributes.length > 0).map(({ group: u, attributes: c }) => ({
        title: ne(e, u.displayHeader, u.name) || e("general"),
        panel: /* @__PURE__ */ v("div", { className: "pf-v5-c-form", children: [
          u.displayDescription && /* @__PURE__ */ t(Be, { className: "pf-v5-u-pb-lg", children: ne(e, u.displayDescription, "") }),
          c.map((h) => /* @__PURE__ */ t(
            Ca,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: i,
              renderer: s,
              attribute: h
            },
            h.name
          ))
        ] })
      }))
    }
  );
}, Ca = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: i,
  attribute: l
}) => {
  const s = n.watch(
    Q(l.name)
  ), o = q(() => Ia(l), [l]), u = l.multivalued || ka(s) && l.annotations?.inputType === void 0 ? Ge["multi-input"] : Ge[o];
  return l.name === "locale" ? /* @__PURE__ */ t(
    pa,
    {
      form: n,
      supportedLocales: a,
      currentLocale: i,
      t: e,
      attribute: l
    }
  ) : /* @__PURE__ */ t(
    u,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: l,
      renderer: r
    }
  );
}, wa = "text";
function Ia(e) {
  if (zt(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return Ta(n) ? n : wa;
}
const Ta = (e) => typeof e == "string" && e in Ge, ka = (e) => Array.isArray(e) && e.length > 1, xa = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ v(
  "svg",
  {
    className: V(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ v("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
);
class Sa extends Lt {
  displayName = "MenuToggleBase";
  static defaultProps = {
    className: "",
    isExpanded: !1,
    isDisabled: !1,
    isFullWidth: !1,
    isFullHeight: !1,
    ouiaSafe: !0
  };
  state = {
    ouiaStateId: On("MenuToggle", this.props.variant)
  };
  render() {
    const {
      children: n,
      className: r,
      icon: a,
      badge: i,
      isExpanded: l,
      isDisabled: s,
      isFullHeight: o,
      isFullWidth: u,
      splitButtonOptions: c,
      variant: h,
      status: d,
      statusIcon: y,
      innerRef: b,
      onClick: C,
      "aria-label": x,
      ouiaId: p,
      ouiaSafe: m,
      // picture,
      // avatar,
      ...S
    } = this.props, T = h === "plain", w = h === "plainText", f = h === "typeahead", I = Dn(
      "MenuToggle",
      p ?? this.state.ouiaStateId,
      m
    );
    let N = y;
    if (!y)
      switch (d) {
        case "success":
          N = /* @__PURE__ */ t(kr, { "aria-hidden": "true" });
          break;
        case "warning":
          N = /* @__PURE__ */ t(Sr, { "aria-hidden": "true" });
          break;
        case "danger":
          N = /* @__PURE__ */ t(xr, { "aria-hidden": "true" });
          break;
      }
    const R = /* @__PURE__ */ v("span", { className: V(P.menuToggleControls), children: [
      d !== void 0 && /* @__PURE__ */ t("span", { className: V(P.menuToggleStatusIcon), children: N }),
      /* @__PURE__ */ t("span", { className: V(P.menuToggleToggleIcon), children: /* @__PURE__ */ t(Tr, { "aria-hidden": !0 }) })
    ] }), B = /* @__PURE__ */ v(j, { children: [
      a && /* @__PURE__ */ t("span", { className: V(P.menuToggleIcon), children: a }),
      f ? n : /* @__PURE__ */ t("span", { className: V(P.menuToggleText), children: n }),
      Bt(i) && /* @__PURE__ */ t("span", { className: V(P.menuToggleCount), children: i }),
      f ? /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: V(P.menuToggleButton),
          "aria-expanded": l,
          onClick: C,
          "aria-label": x || "Menu toggle",
          tabIndex: -1,
          ...I,
          children: R
        }
      ) : R
    ] }), _ = V(
      P.menuToggle,
      l && P.modifiers.expanded,
      h === "primary" && P.modifiers.primary,
      h === "secondary" && P.modifiers.secondary,
      d && P.modifiers[d],
      (T || w) && P.modifiers.plain,
      w && P.modifiers.text,
      o && P.modifiers.fullHeight,
      u && P.modifiers.fullWidth,
      s && P.modifiers.disabled,
      r
    ), M = {
      children: T ? n : B,
      ...s && { disabled: !0 },
      ...S
    };
    return f ? /* @__PURE__ */ t(
      "div",
      {
        ref: b,
        className: V(_, P.modifiers.typeahead),
        ...M
      }
    ) : c ? /* @__PURE__ */ v(
      "div",
      {
        ref: b,
        className: V(
          _,
          P.modifiers.splitButton,
          c?.variant === "action" && P.modifiers.action
        ),
        children: [
          c?.items,
          /* @__PURE__ */ v(
            "button",
            {
              className: V(
                P.menuToggleButton,
                n && P.modifiers.text
              ),
              type: "button",
              "aria-expanded": l,
              "aria-label": x,
              disabled: s,
              onClick: C,
              ...S,
              ...I,
              children: [
                n && /* @__PURE__ */ t("span", { className: V(P.menuToggleText, "avatar-display"), children: n }),
                R
              ]
            }
          )
        ]
      }
    ) : /* @__PURE__ */ t(
      "button",
      {
        className: V(_),
        type: "button",
        "aria-label": x,
        "aria-expanded": l,
        ref: b,
        disabled: s,
        onClick: C,
        ...M,
        ...I
      }
    );
  }
}
const Yt = Dt(
  (e, n) => /* @__PURE__ */ t(Sa, { innerRef: n, ...e })
);
Yt.displayName = "MenuToggle";
const Ct = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  picture: a,
  avatar: i,
  ...l
}) => {
  const [s, o] = A(!1);
  return /* @__PURE__ */ t(
    Pn,
    {
      className: "avatar-width",
      ...l,
      popperProps: {
        position: "right"
      },
      onOpenChange: (u) => o(u),
      toggle: (u) => /* @__PURE__ */ t("div", { className: "image-icon", style: { width: "100%" }, children: /* @__PURE__ */ t(
        Yt,
        {
          "data-testid": `${l["data-testid"]}-toggle`,
          style: { width: "100%" },
          ref: u,
          onClick: () => o(!s),
          isExpanded: s,
          variant: e ? "plain" : "default",
          picture: a,
          avatar: i,
          children: e ? /* @__PURE__ */ t(fr, {}) : n
        }
      ) }),
      isOpen: s,
      children: /* @__PURE__ */ t(Mn, { children: r })
    }
  );
};
function Ea(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, i = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || i || n("unknownUser");
}
const vi = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...i },
  avatar: l,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: u = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: h = [],
  toolbarItems: d,
  toolbar: y,
  ...b
}) => {
  const { t: C } = K(), [x, p] = A(!1), [m, S] = A("");
  re(() => {
    const f = () => {
      p(window.innerWidth <= 1200);
    };
    f(), window.addEventListener("resize", f);
    const I = e.idTokenParsed?.lastLoginTime;
    if (I && !isNaN(Number(I))) {
      const N = Number(I), R = new Date(N);
      isNaN(R.getTime()) ? S("Never") : S(R.toLocaleString());
    } else
      S("Never");
    return () => {
      window.removeEventListener("resize", f);
    };
  }, [e]);
  const T = [];
  o && T.push(
    /* @__PURE__ */ t(
      ut,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), s && T.push(
    /* @__PURE__ */ t(ut, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const w = e.idTokenParsed?.picture;
  return /* @__PURE__ */ v(Fn, { ...b, children: [
    /* @__PURE__ */ t(Ln, { children: x && /* @__PURE__ */ t(Bn, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(gr, {}) }) }),
    /* @__PURE__ */ t(Vn, { ...i, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ v(_n, { children: [
      y,
      /* @__PURE__ */ t(we, { style: { backgroundColor: "#002a4f" }, children: /* @__PURE__ */ v(Ue, { children: [
        d?.map((f, I) => /* @__PURE__ */ t(W, { align: { default: "alignRight" }, children: f }, I)),
        /* @__PURE__ */ t(
          W,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: m ? /* @__PURE__ */ v("span", { children: [
              "Last login: ",
              m
            ] }) : /* @__PURE__ */ t("span", { children: "Never" })
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              Ct,
              {
                "data-testid": "options",
                dropDownItems: [...h, T],
                title: u ? Ea(e.idTokenParsed, C) : void 0,
                picture: w,
                avatar: l
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              Ct,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || h,
                  T
                ],
                picture: w,
                avatar: l
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: w || l?.src ? /* @__PURE__ */ t(Un, { src: w, alt: C("avatar"), ...l }) : /* @__PURE__ */ t(xa, { ...l })
          }
        )
      ] }) })
    ] })
  ] });
}, Zt = tt("ErrorBoundaryContext", void 0), Qt = () => nt(Zt);
class Ci extends Lt {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Zt.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const wi = ({ children: e, fallback: n }) => {
  const { error: r } = Qt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function Aa(e, n, r) {
  const { showBoundary: a } = Qt();
  re(() => {
    const i = new AbortController(), { signal: l } = i;
    return e().then((s) => {
      l.aborted || n(s);
    }).catch((s) => {
      console.error(s), l.aborted || a(s);
    }), () => i.abort();
  }, r);
}
const Ra = () => {
  const { t: e } = K();
  return /* @__PURE__ */ t($n, { children: /* @__PURE__ */ t(kt, { "aria-label": e("spinnerLoading") }) });
}, Na = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: i,
  primaryActionText: l,
  secondaryActions: s,
  icon: o,
  isDisabled: u = !1
}) => /* @__PURE__ */ v(qn, { "data-testid": "empty-state", variant: "lg", children: [
  a && i ? /* @__PURE__ */ t(ht, { icon: yr }) : a && /* @__PURE__ */ t(ht, { icon: o || Ut }),
  /* @__PURE__ */ t(Kn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Hn, { children: n }),
  /* @__PURE__ */ v(Gn, { children: [
    l && /* @__PURE__ */ t(
      $,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: u,
        children: l
      }
    ),
    s && /* @__PURE__ */ t(Wn, { children: s.map((c) => /* @__PURE__ */ t(
      $,
      {
        "data-testid": `${c.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: c.type || Ie.secondary,
        onClick: c.onClick,
        isDisabled: u,
        children: c.text
      },
      c.text
    )) })
  ] })
] }), Oa = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: i,
  inputGroupName: l,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: u } = K(), [c, h] = A(""), d = (b) => {
    h(b.trim()), o?.(b.trim());
  }, y = (b) => {
    b.key === "Enter" && d(c);
  };
  return /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(we, { "data-testid": "table-toolbar", children: /* @__PURE__ */ v(Ue, { children: [
      l && /* @__PURE__ */ t(W, { children: /* @__PURE__ */ v(ke, { "data-testid": l, children: [
        i,
        s && /* @__PURE__ */ t(
          jn,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": u("search"),
            value: c,
            onChange: (b, C) => {
              h(C);
            },
            onSearch: () => d(c),
            onKeyDown: y,
            onClear: () => d("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(we, { children: /* @__PURE__ */ t(Ue, { children: n }) }),
    /* @__PURE__ */ t(zn, {}),
    a,
    /* @__PURE__ */ t(we, { children: r })
  ] });
}, wt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: i,
  onNextClick: l,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: u } = K(), c = Math.round(a / i);
  return /* @__PURE__ */ t(
    Jn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${u("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: h,
        lastIndex: d
      }) => /* @__PURE__ */ v("b", { children: [
        h,
        " - ",
        d
      ] }),
      itemCount: r + c * i,
      page: c + 1,
      perPage: i,
      onNextClick: (h, d) => l((d - 1) * i),
      onPreviousClick: (h, d) => s((d - 1) * i),
      onPerPageSelect: (h, d, y) => o(y - 1, d),
      variant: n
    }
  );
}, Da = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: i,
  inputGroupName: l,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...u
}) => /* @__PURE__ */ t(
  Oa,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ v(j, { children: [
      r,
      /* @__PURE__ */ t(W, { variant: "pagination", children: /* @__PURE__ */ t(wt, { count: e, ...u }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(W, { variant: "pagination", children: /* @__PURE__ */ t(wt, { count: e, variant: "bottom", ...u }) }) : null,
    inputGroupName: l,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: i
  }
), Xt = (e) => !!e && e.title !== void 0, It = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => /* @__PURE__ */ v(j, { children: [
  e.cells.map((i, l) => /* @__PURE__ */ t(ie, { children: Xt(i) ? i.title : i }, `cell-${l}`)),
  (r || a) && /* @__PURE__ */ t(ie, { isActionCell: !0, children: /* @__PURE__ */ t(
    Or,
    {
      items: r || a?.(e, {}),
      extraData: { rowIndex: n }
    }
  ) })
] }), Pa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: Xt(n) ? n.title : n }, `cell-${r}`));
function Ma({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: i,
  selected: l,
  onSelect: s,
  onCollapse: o,
  canSelectAll: u,
  canSelect: c,
  isNotCompact: h,
  isRadio: d,
  ...y
}) {
  const { t: b } = K(), [C, x] = A(l || []), [p, m] = A([]), S = q(
    () => Ir(
      C,
      n.map((f) => f.data),
      "id"
    ),
    [C, n]
  );
  re(() => {
    if (u) {
      const f = document.getElementsByName("check-all").item(0);
      if (f) {
        const I = f;
        I.indeterminate = S.length < n.length && S.length > 0;
      }
    }
  }, [C, u, n]);
  const T = (f) => {
    x(f), s?.(f);
  }, w = (f, I) => {
    if (d) {
      const N = I ? [n[f].data] : [];
      T(N);
    } else if (f === -1) {
      const N = S.map(
        (R) => U(R, "id")
      );
      T(
        I ? [...C, ...n.map((R) => R.data)] : C.filter(
          (R) => !N.includes(U(R, "id"))
        )
      );
    } else
      T(I ? [...C, n[f].data] : C.filter(
        (N) => U(N, "id") !== n[f].data.id
      ));
  };
  return /* @__PURE__ */ v(
    Er,
    {
      ...y,
      variant: h ? void 0 : Ar.compact,
      "aria-label": b(i),
      children: [
        /* @__PURE__ */ t(Rr, { children: /* @__PURE__ */ v(ve, { children: [
          o && /* @__PURE__ */ t(Me, { screenReaderText: b("expandRow") }),
          u && /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: b("selectAll"),
              select: d ? void 0 : {
                onSelect: (f, I) => {
                  w(-1, I);
                },
                isSelected: S.length === n.length
              }
            }
          ),
          e.map((f) => /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: b("expandRow"),
              className: f.transforms?.[0]().className,
              children: b(f.displayKey || f.name)
            },
            f.displayKey || f.name
          ))
        ] }) }),
        o ? n.map((f, I) => /* @__PURE__ */ t(mt, { children: I % 2 === 0 ? /* @__PURE__ */ v(ve, { children: [
          /* @__PURE__ */ t(
            ie,
            {
              expand: n[I + 1].cells.length === 0 ? void 0 : {
                isExpanded: !!p[I],
                rowIndex: I,
                expandId: "expandable-row-",
                onToggle: (N, R, B) => {
                  o(B, R);
                  const _ = [...p];
                  _[I] = B, m(_);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            It,
            {
              row: f,
              index: I,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ v(ve, { isExpanded: !!p[I - 1], children: [
          /* @__PURE__ */ t(ie, {}),
          /* @__PURE__ */ t(ie, { colSpan: e.length, children: /* @__PURE__ */ t(Nr, { children: /* @__PURE__ */ t(Pa, { row: f }) }) })
        ] }) }, I)) : /* @__PURE__ */ t(mt, { children: n.map((f, I) => /* @__PURE__ */ v(ve, { isExpanded: p[I], children: [
          c && /* @__PURE__ */ t(
            ie,
            {
              select: {
                rowIndex: I,
                onSelect: (N, R, B) => {
                  w(B, R);
                },
                isSelected: !!C.find(
                  (N) => U(N, "id") === f.data.id
                ),
                variant: d ? "radio" : "checkbox"
              }
            }
          ),
          /* @__PURE__ */ t(
            It,
            {
              row: f,
              index: I,
              actions: r,
              actionResolver: a
            }
          )
        ] }, I)) })
      ]
    }
  );
}
function Fa({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: i = !1,
  isNotCompact: l,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: u,
  loader: c,
  columns: h,
  actions: d,
  actionResolver: y,
  searchTypeComponent: b,
  toolbarItem: C,
  subToolbar: x,
  emptyState: p,
  icon: m,
  isSearching: S = !1,
  ...T
}) {
  const { t: w } = K(), [f, I] = A([]), [N, R] = A(), [B, _] = A(), [M, g] = A(!1), [E, O] = Kt(
    localStorage,
    "pageSize",
    10
  ), [D, oe] = A(E), [H, ce] = A(0), [z, Oe] = A(""), at = Z(), [fe, nn] = A(0), it = Z(), lt = () => nn(fe + 1), rn = Pt(), st = (k, F) => k.map((L) => {
    if ("cellFormatters" in L) {
      const ee = U(F, L.name);
      return L.cellFormatters?.reduce((de, ye) => ye(de), ee);
    }
    if (L.cellRenderer) {
      const ee = L.cellRenderer;
      return { title: /* @__PURE__ */ t(ee, { ...F }) };
    }
    return U(F, L.name);
  }), ot = (k) => {
    const F = (L) => o?.[0]?.enabled?.(L);
    return k.map((L, ee) => {
      const de = u ? u(L) : !1, ye = [
        {
          data: L,
          disableSelection: de,
          disableActions: de,
          selected: !!f.find((cn) => U(cn, "id") === U(L, "id")),
          isOpen: F(L) ? !1 : void 0,
          cells: st(h, L)
        }
      ];
      return o && ye.push({
        parent: ee * 2,
        cells: F(L) ? st(o, L) : []
      }), ye;
    }).flat();
  }, De = (k) => ["string", "number"].includes(typeof k) ? k.toString() : k instanceof Array ? k.map(De).join("") : typeof k == "object" ? De(
    Bt(k.title) ? k.title.props : Object.values(k)
  ) : "", ct = q(
    () => z === "" || r ? void 0 : ot(B || []).filter(
      (k) => k.cells.some(
        (F) => F && De(F).toLowerCase().includes(z.toLowerCase())
      )
    ).slice(H, H + D + 1),
    [z, H, D]
  );
  Aa(
    async () => {
      g(!0);
      const k = at.current === "" && z !== "";
      return k && ce(0), at.current = z, typeof c == "function" ? fe === it.current && B ? B : await c(k ? 0 : H, D + 1, z) : c;
    },
    (k) => {
      it.current = fe, r || (_(k), k.length > H ? k = k.slice(H, H + D + 1) : ce(0));
      const F = ot(k);
      R(F), g(!1);
    },
    [
      fe,
      H,
      D,
      z,
      typeof c != "function" ? c : void 0
    ]
  );
  const an = () => d && wr(d).map((k, F) => (delete k.onRowClick, k.onClick = async (L, ee) => {
    await d[F].onRowClick(
      (ct || N)[ee].data
    ) && (r || Oe(""), lt());
  }, k)), ln = (k, F) => {
    X[F].isOpen = k, R([...X]);
  }, X = ct || N, ge = !X || X.length === 0, Pe = z !== "" || S, sn = o ? D * 2 : D, on = o ? (X?.length || 0) / 2 : X?.length || 0;
  return /* @__PURE__ */ v(j, { children: [
    (!ge || Pe) && /* @__PURE__ */ v(
      Da,
      {
        id: rn,
        count: on,
        first: H,
        max: D,
        onNextClick: ce,
        onPreviousClick: ce,
        onPerPageSelect: (k, F) => {
          ce(k), oe(F), O(F);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Oe,
        inputGroupPlaceholder: w(n || ""),
        searchTypeComponent: b,
        toolbarItem: /* @__PURE__ */ v(j, { children: [
          C,
          " ",
          /* @__PURE__ */ t(W, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(W, { children: /* @__PURE__ */ v($, { variant: "link", onClick: lt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(br, {}),
            " ",
            w("refresh")
          ] }) })
        ] }),
        subToolbar: x,
        children: [
          !M && !ge && /* @__PURE__ */ t(
            Ma,
            {
              ...T,
              canSelectAll: i,
              canSelect: !!a,
              selected: f,
              onSelect: (k) => {
                I(k), a?.(k);
              },
              onCollapse: o ? ln : void 0,
              actions: an(),
              actionResolver: y,
              rows: X.slice(0, sn),
              columns: h,
              isNotCompact: l,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !M && ge && Pe && /* @__PURE__ */ t(
            Na,
            {
              hasIcon: !0,
              icon: m,
              isSearchVariant: !0,
              message: w("noSearchResults"),
              instructions: w("noSearchResultsInstructions"),
              secondaryActions: S ? [] : [
                {
                  text: w("clearAllFilters"),
                  onClick: () => Oe(""),
                  type: Ie.link
                }
              ]
            }
          )
        ]
      }
    ),
    M && /* @__PURE__ */ t(Ra, {}),
    !M && ge && !Pe && p
  ] });
}
const La = ({ link: e, organization: n }) => {
  const { t: r } = K();
  return /* @__PURE__ */ t(Dr, { wrapModifier: "truncate", children: /* @__PURE__ */ v(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      Yn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Ba = (e) => {
  const { t: n } = K();
  return /* @__PURE__ */ t(
    Qe,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Xe, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, Ii = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: i,
  onSelect: l,
  onDelete: s,
  deleteLabel: o = "delete",
  link: u,
  children: c
}) => {
  const { t: h } = K();
  return /* @__PURE__ */ t(
    Fa,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: i,
      toolbarItem: n,
      onSelect: l,
      canSelectAll: l !== void 0,
      actions: s ? [
        {
          title: h(o),
          onRowClick: s
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (d) => /* @__PURE__ */ t(La, { link: u, organization: d })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Ba
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: c
    }
  );
}, en = 128, We = 32;
function tn() {
  var e = Va(414, 10, 160).toString(16);
  return e.length > 32 && e.substring(0, 32), e;
}
function Va(e, n, r) {
  const a = _a(r);
  for (var i = 0n, l = n; l <= r; l++) i = i + a[l] * BigInt(Math.abs(l * l - e));
  return i;
}
function _a(e) {
  const n = [0n, 1n];
  for (var r = 2; r <= e; r++) n.push(n[r - 1] + n[r - 2]);
  return n;
}
async function Ti(e) {
  const n = crypto.getRandomValues(new Uint8Array(We)), r = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(tn()),
    { name: "AES-GCM" },
    !1,
    ["encrypt"]
  ), a = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv: n, tagLength: en },
    r,
    new TextEncoder().encode(e)
  ), i = new Uint8Array(a), l = new Uint8Array(n.length + i.length);
  return l.set(n, 0), l.set(i, n.length), btoa(String.fromCharCode(...l));
}
async function ki(e) {
  const n = Uint8Array.from(atob(e), (s) => s.charCodeAt(0)), r = n.slice(0, We), a = n.slice(We), i = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(tn()),
    { name: "AES-GCM" },
    !1,
    ["decrypt"]
  ), l = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: r, tagLength: en },
    i,
    a
  );
  return new TextDecoder().decode(l);
}
export {
  qr as AlertProvider,
  si as ContinueCancelModal,
  wi as ErrorBoundaryFallback,
  Ci as ErrorBoundaryProvider,
  Kr as ErrorPage,
  Gt as FormErrorText,
  ia as FormPanel,
  yi as FormSubmitButton,
  jr as Help,
  Wt as HelpItem,
  gi as IconMapper,
  Fa as KeycloakDataTable,
  vi as KeycloakMasthead,
  ii as KeycloakProvider,
  ba as KeycloakSelect,
  Ra as KeycloakSpinner,
  ta as KeycloakTextArea,
  Na as ListEmptyState,
  oi as NumberControl,
  Ii as OrganizationTable,
  Da as PaginatingTableToolbar,
  ci as PasswordControl,
  jt as PasswordInput,
  da as ScrollForm,
  Qr as SelectControl,
  ue as SelectVariant,
  pi as SwitchControl,
  Oa as TableToolbar,
  mi as TextAreaControl,
  fi as TextControl,
  bi as UserProfileFields,
  di as beerify,
  tt as createNamedContext,
  ea as debeerify,
  ki as decrypt,
  Ti as encrypt,
  Br as generateId,
  Fr as getErrorDescription,
  Mr as getErrorMessage,
  li as getInjectedEnvironment,
  $t as getNetworkErrorDescription,
  Lr as getNetworkErrorMessage,
  Vr as isDefined,
  hi as isUserProfileError,
  ne as label,
  ca as mainPageContentId,
  ui as setUserProfileServerError,
  ri as useAlerts,
  ai as useEnvironment,
  Qt as useErrorBoundary,
  Aa as useFetch,
  Wr as useHelp,
  nt as useRequiredContext,
  _r as useSetTimeout,
  Kt as useStoredState
};
